import React, { useState, useEffect, useRef } from "react";
import Layout from "./layout";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import DateInput from "../components/DateInput";
import Button from "../components/Button";
import { Row } from "react-bootstrap";
import DataTable from "../components/DataTable";
import SearchBar from "../components/Searchbar";
import SessionData from "../assets/json/sessiondata.json";
import Popularpage from "../components/PopularPages.js";
import LiveConversion from "../components/LiveConversionUserBehaviour.js";

const AnalyticsReport = () => {
    const navigate = useNavigate();
    const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
    const tableRef = useRef();
    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };
    const columns = [
        { headname: "SESSION ID", dbcol: "col1", type: "text" },
        { headname: "USER DEVICE/BROWSER", dbcol: "col2", type: "time" },
        { headname: "TIME SPENT", dbcol: "col3", type: "text" },
        { headname: "DATE AND TIME", dbcol: "col4", type: "time" },
        { headname: "", dbcol: "col5", type: "custom" },
    ];


    return (
        <Layout>
            <div className="d-flex align-items-center justify-content-between">

                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />

                </div>
            </div>

            <SearchBar />

            <div className="form_section">
                <h6 className="card-title">Heatmaps</h6>

                <div className="row">
                    <div className="col p-3">
                        <a
                            className="search-input-wrapper"
                            onClick={() => setCustomerModalOpen(true)}
                        >
                            <div className="ae-search-container">
                                <i class="bi bi-search"></i> Search for a page to view its heatmap
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <Row>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Popular Pages</h3>
                            <Popularpage />
                        </div>
                    </Col>

                    <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Live Conversion</h3>
                            <LiveConversion/>
                        </div>
                    </Col>
                </Row>
            </div>

            <div style={{
                background: "#fff",
                padding: "24px",
                marginTop: "20px",
            }}>
                <h3 style={{ marginBottom: "20px", color: "#1A1F36", fontWeight: "600" }}>
                    Session Replay
                </h3>

                <DataTable
                    id="SessionData"
                    columns={columns}
                    data={SessionData}
                    defaultView="table"
                    searchable={true}
                    filterable={true}
                    sortable={true}
                    paginated={true}
                />
            </div>
        </Layout>
    )
}

export default AnalyticsReport;
